/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useWeb3React } from '@web3-react/core'
import { Dropdown, Menu, Switch } from 'antd'
import Avatar from 'components/Avatar'
import useIsMobile from 'hooks/useIsMobile'
import { useRouter } from 'next/router'
import React, { useRef, useState } from 'react'
import styled from 'styled-components'
import { Flex, Link } from 'widgets'

const CustomeMenu = styled.div`
  .ant-dropdown-menu {
    background: #ffffff;
    box-shadow: 1px 0px 2px rgba(0, 0, 0, 0.79);
    border-radius: 10px;
    border: none;
    min-width: 112px;
    padding: 0;
    overflow: hidden;

    ${({ theme }) => theme.mediaQueries.lg} {
      background: rgba(255, 255, 255, 0.7);
      backdrop-filter: blur(5px);
    }

    .ant-dropdown-menu-title-content {
      display: flex;
      align-items: center;
      font-family: 'Inter';
      font-style: normal;
      font-weight: 700;
      color: #000000;

      a {
        > img {
          margin-right: 6px;
          width: 25px;
        }
      }

      .ant-switch-inner {
        img {
          width: 18px;
        }
      }
    }
  }

  .ant-switch {
    background-color: #1890ff;
    margin-left: 21px;
  }

  .ant-dropdown-menu-item:hover,
  .ant-dropdown-menu-submenu-title:hover,
  .ant-dropdown-menu-item.ant-dropdown-menu-item-active,
  .ant-dropdown-menu-item.ant-dropdown-menu-submenu-title-active,
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-item-active,
  .ant-dropdown-menu-submenu-title.ant-dropdown-menu-submenu-title-active {
    /* background: rgba(0, 109, 254, 0.2); */
    background: #fff;
    box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.5);
    border-radius: 3px;

    .ant-dropdown-menu-title-content {
      /* color: #006dfe; */
      color: #000;
    }
  }

  .ant-dropdown-menu-item {
    padding: 0;

    a {
      position: relative;
      display: block;
      width: 100%;
      padding: 5px 12px;

      img {
        &:nth-child(1) {
          opacity: 1;
        }

        &:nth-child(2) {
          position: absolute;
          top: 5px;
          left: 12px;
          z-index: 1;
          opacity: 0;
        }
      }
    }

    &.item-active {
      background: rgba(0, 109, 254, 0.2);

      .ant-dropdown-menu-title-content {
        color: #006dfe;
      }

      a {
        img {
          &:nth-child(1) {
            opacity: 0;
          }

          &:nth-child(2) {
            opacity: 1;
          }
        }
      }
    }
  }

  .avatar-image {
    object-fit: contain;
  }

  .ant-switch {
    .ant-switch-inner {
      img {
        margin: 0;
      }
    }

    .light-mode {
      transform: translateY(-5px);
      animation: switch-dark-mode 1s;
      animation-fill-mode: forwards;
    }

    .dark-mode {
      transform: translateY(5px);
      animation: switch-dark-mode-2 1s;
      animation-fill-mode: forwards;
    }
  }
`

const WrappMenuAccount = styled.div`
  .avatar-image {
    width: 42px;
    height: 42px;
    object-fit: cover;
    border-radius: 50%;
  }
`

const menu = ({ avatar, asPathRouter, checkedMode, setCheckedMode, onCloseDropdown }) => (
  <CustomeMenu>
    <Menu>
      <Menu.Item
        className={asPathRouter === '/account' ? 'item-active' : ''}
        onClick={() => onCloseDropdown((prev) => !prev)}
      >
        <Link href="/account">
          <Flex>
            <div style={{ marginRight: '5px' }}>
              <Avatar
                avatar={avatar || '/images/account/avatar-image-default.png'}
                height="25px"
                width="25px"
                transform="scale(0.23) translate(-164%,-167%)"
              />
            </div>
            <span>My Account</span>
          </Flex>
        </Link>
      </Menu.Item>
      <Menu.Item
        className={asPathRouter === '/account/my-nfts' ? 'item-active' : ''}
        onClick={() => onCloseDropdown((prev) => !prev)}
      >
        <Link href="/account/my-nfts">
          <img src="/images/account/icons/my-nft.svg" alt="" />
          <img src="/images/account/icons/my-nft-blue.svg" alt="" />
          <span>My NFT</span>
        </Link>
      </Menu.Item>
      {/* <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="#">
          <img src="/images/account/icons/kyc.svg" alt="" />
          <img src="/images/account/icons/kyc-blue.svg" alt="" />
          <span>KYC</span>
        </Link>
      </Menu.Item> */}
      <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="/account/more?action=favorite">
          <img src="/images/account/icons/my-favorite.svg" alt="" />
          <img src="/images/account/icons/my-favorite-blue.svg" alt="" />
          <span>My Favorite</span>
        </Link>
      </Menu.Item>
      {/* <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="#">
          <img src="/images/account/icons/my-watchlist.svg" alt="" />
          <img src="/images/account/icons/my-watchlist-blue.svg" alt="" />
          <span>My Watchlist</span>
        </Link>
      </Menu.Item> */}
      {/* <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="#">
          <img src="/images/account/icons/my-ads.svg" alt="" />
          <span>My Ads</span>
        </Link>
      </Menu.Item>
      <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="#">
          <img src="/images/account/icons/referral.svg" alt="" style={{ filter: 'blue' }} />
          <span>My Referal</span>
        </Link>
      </Menu.Item> */}
      <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <Link href="/settings">
          <img src="/images/account/icons/settings.svg" alt="" />
          <img src="/images/account/icons/settings-blue.svg" alt="" />
          <span>Settings</span>
        </Link>
      </Menu.Item>
      {/* <Menu.Item onClick={() => onCloseDropdown((prev) => !prev)}>
        <div onClick={() => setCheckedMode((prev) => !prev)}>
          <a>
            <img src="/images/account/icons/light-dark-mode.svg" alt="" />
            <span>Light - Dark Mode</span>
          </a>
        </div>
        <Switch
          checkedChildren={<img className="light-mode" src="/images/account/icons/light.svg" alt="" />}
          unCheckedChildren={<img className="dark-mode" src="/images/account/icons/dark.svg" alt="" />}
          checked={checkedMode}
          onChange={(e) => setCheckedMode(e)}
        />
      </Menu.Item> */}
    </Menu>
  </CustomeMenu>
)

const MenuAccount = ({ userInfo, refContainerDropdown }: { userInfo: any; refContainerDropdown: any }) => {
  const [visibleDropdown, setVisibleDropdown] = useState(false)
  const [checkedMode, setCheckedMode] = useState(false)
  const isMobile = useIsMobile(1024)

  const router = useRouter()
  const asPathRouter = router.asPath.split('?')[0]

  const handleVisibleChange = (flag: boolean) => {
    setVisibleDropdown(flag)
  }

  return (
    <>
      <WrappMenuAccount
        style={isMobile ? { margin: 'auto', cursor: 'pointer' } : { margin: '0 12px 0 24px', cursor: 'pointer' }}
        id="area_dropdown_account"
      >
        <Dropdown
          overlay={menu({
            avatar: userInfo?.data?.profile?.avatar,
            asPathRouter,
            checkedMode,
            setCheckedMode,
            onCloseDropdown: setVisibleDropdown,
          })}
          placement="bottom"
          trigger={['click']}
          open={!isMobile ? visibleDropdown : false}
          onOpenChange={handleVisibleChange}
          getPopupContainer={() => refContainerDropdown.current}
        >
          <Avatar
            onClick={() => setVisibleDropdown((prev) => !prev)}
            avatar={
              userInfo?.data?.profile?.avatar
                ? userInfo?.data?.profile?.avatar
                : '/images/account/avatar-image-default.png'
            }
          />
        </Dropdown>
      </WrappMenuAccount>
    </>
  )
}

export default MenuAccount
